/**
 * Функция добавляет в массив `arr` несколько элементов так,
 * чтобы финальная длина составила `finalSize`.
 * Каждый новый элемент создается с помощью вызова `getValue`.
 *
 * @example arrayPadEnd([1, 2, 3, 4, 5], () => 9, 7) => [1, 2, 3, 4, 5, 9, 9]
 *
 * @param arr массив, в который добавляем элементы в конец
 * @param getValue функция конструктор очередного элемента
 * @param finalSize результирующая длина нового массива
 */
export const arrayPadEnd = <Item>(
  arr: Item[],
  getValue: (index: number) => Item,
  finalSize: number
): Item[] => {
  const newArr = [...arr];

  for (let i = arr.length; i < finalSize; i++) {
    newArr.push(getValue(i));
  }

  return newArr;
};
